/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import cs from 'classnames';
import { useMemo } from 'react';
import {
    Col,
    Image, List, Row, Space, Tooltip, Typography,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import { checkDriverStatus, driverMarkerImage } from '../../utils/driver.util';

interface Props {
    lat: number;
    lng: number;
    driverID: string;
    driverUniqueID: string;
    name: string;
    lastName: string;
    email: string;
    mobile: string;
    isBusy: boolean;
    onDutyFlag: boolean;
    driverMarkerSelected: string | null;
    updatedDriverMarkerSelected: (driverUniqueID: string) => void;
}
const { Text, Title } = Typography;
const DriverMarker = ({
    lat,
    lng,
    driverID,
    driverUniqueID,
    name,
    lastName,
    email,
    mobile,
    isBusy,
    onDutyFlag,
    driverMarkerSelected,
    updatedDriverMarkerSelected,
}: Props) => {
    const { t } = useTranslation('drivers', { keyPrefix: 'DRIVERS' });
    const status = checkDriverStatus(isBusy, onDutyFlag);

    // const {
    //     setOpenDrawer,
    // } = useContext(MyFleetContext);

    const [searchParams, setSearchParams] = useSearchParams();

    const handlePhoneClick = (e: any) => {
        e.stopPropagation();
        if (!mobile) return null;
        window.open(`https://wa.me/${mobile}`);
    };

    const handleClick = () => {
        searchParams.set('driverID', driverID);
        setSearchParams(searchParams);
        // setOpenDrawer(true);
    };

    const image: string = useMemo(
        () => driverMarkerImage(status),
        [driverUniqueID],
    );

    const informationUser = [
        {
            icon: <AiOutlineMail size={15} color="6C8EEF" />,
            text: email,
            type: 'email',
        },
        {
            icon: <AiOutlinePhone size={15} color="6C8EEF" />,
            text: mobile,
            type: 'phone',
        },
        {
            icon: <div className={cs('driver-dot', status)} />,
            text: t(status),
            type: 'status',
        },
    ];

    const driverInfo = () => (
        <div className="cards__driver">
            <List.Item.Meta
                style={{ width: '100%' }}
                title={(
                    <Col>
                        <Title
                            level={5}
                            style={{ margin: 0 }}
                        >
                            {`${name} ${lastName}`}
                        </Title>
                    </Col>
                )}
                description={(
                    <Space direction="vertical" style={{ marginTop: '20px' }}>
                        <Text
                            style={{
                                fontSize: '10px',
                                fontWeight: 'bolder',
                            }}
                            type="secondary"
                        >
                            {t('INFORMATION')}
                        </Text>
                        {informationUser.map((info) => (
                            <Col>
                                <Row
                                    align="middle"
                                    justify="start"
                                    onClick={
                                        info.type === 'phone' ? handlePhoneClick : () => { }
                                    }
                                >
                                    {info.icon}
                                    <Text
                                        className={info.type === 'phone' ? 'booking__info--text-value link' : ''}
                                        style={{
                                            marginLeft: '10px',
                                            cursor: info.type === 'phone' ? 'pointer' : 'none',
                                            fontSize: '12px',
                                        }}
                                    >
                                        {info.text}
                                    </Text>
                                </Row>
                            </Col>
                        ))}
                    </Space>
                )}
            />
        </div>
    );

    return (
        <Tooltip
            title={driverInfo()}
            color="white"
            overlayInnerStyle={{ borderRadius: '10px', padding: '14px' }}
        >
            <Image
                id={`driver-marker-${driverID}`}
                style={{ cursor: 'pointer' }}
                preview={false}
                width={25}
                alt="driver-marker"
                src={image}
                onClick={handleClick}
            />
        </Tooltip>
    );
};

export { DriverMarker };
